/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPill = createReactComponent("outline", "pill", "IconPill", [["path", { "d": "M4.5 12.5l8 -8a4.94 4.94 0 0 1 7 7l-8 8a4.94 4.94 0 0 1 -7 -7", "key": "svg-0" }], ["path", { "d": "M8.5 8.5l7 7", "key": "svg-1" }]]);

export { IconPill as default };
//# sourceMappingURL=IconPill.mjs.map
